import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	starred: {
		id: 'spa-apps-sidebar-servicedesk.common.practice-queues.starred-section.onboarding.spotlight.starred',
		defaultMessage: 'Starred',
		description: 'Bold Text displayed to user inside Starred Queue onboarding.',
	},
	title: {
		id: 'spa-apps-sidebar-servicedesk.common.practice-queues.starred-section.onboarding.spotlight.title',
		defaultMessage: 'Personalized for you',
		description: 'Title of the Starred Queue onboarding.',
	},
	description: {
		id: 'spa-apps-sidebar-servicedesk.common.practice-queues.starred-section.onboarding.spotlight.description',
		defaultMessage: 'Handpick your favorite queues and access them quickly from {starred}.',
		description: 'Description of the Starred Queue onboarding.',
	},
	actionText: {
		id: 'spa-apps-sidebar-servicedesk.common.practice-queues.starred-section.onboarding.spotlight.action-text',
		defaultMessage: 'Got it',
		description: 'Starred Queue onboarding action text',
	},
});
